var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.comentarios.length === 0)?_c('div',{staticClass:"text-center text-gray p-2 text-italic"},[_vm._v("Nenhum comentário")]):_vm._e(),_vm._l((_vm.comentarios),function(comentario,index){return _c('row',{key:index,attrs:{"comentario":comentario}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }